import { IconButton, Tooltip, Typography } from '@material-ui/core'
import FilterCenterFocusOutlinedIcon from '@material-ui/icons/FilterCenterFocusOutlined'
import NavigationOutlinedIcon from '@material-ui/icons/NavigationOutlined'
import SelectAllOutlinedIcon from '@material-ui/icons/SelectAllOutlined'
import { LatLngBounds } from 'leaflet'
import { useMap } from 'react-leaflet'

import CustomControl from '@/components/map/custom-control'
import { useToggleMapMode } from '@/pages/maps/hooks/use-toggle-map-mode'

import { MapMode } from '../../index'
import { useStyles } from './styles'

export interface MapToolsProps {
  mapRef: React.RefObject<L.Map | null>
  bounds?: LatLngBounds | null
  mapMode: MapMode
  setMapMode: (mode: MapMode) => void
}

export const MapTools = ({
  mapRef,
  bounds,
  mapMode,
  setMapMode,
}: MapToolsProps) => {
  const map = useMap()
  const classes = useStyles()
  useToggleMapMode({ mapRef, mapMode, setMapMode })

  const getClassName = (isActive: boolean) =>
    `${classes.iconButton} ${isActive ? classes.activeButton : ''}`

  const buttons = [
    {
      Icon: NavigationOutlinedIcon,
      label: 'Navegar pelo mapa',
      isActive: mapMode === 'navigation',
      onClick: () => setMapMode('navigation'),
    },
    {
      Icon: SelectAllOutlinedIcon,
      label: 'Selecionar múltiplos talhões',
      isActive: mapMode === 'multipleSelection',
      onClick: () => setMapMode('multipleSelection'),
    },
    {
      Icon: FilterCenterFocusOutlinedIcon,
      label: 'Centralizar região',
      isActive: false,
      onClick: () => bounds && map.fitBounds(bounds),
    },
  ]

  return (
    <CustomControl position='bottomleft' className={classes.mapToolsControl}>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <Typography variant='body2' className={classes.toolsTitle}>
          Ferramentas
        </Typography>
        <div className={classes.toolsContainer}>
          {buttons.map(({ Icon, label, isActive, onClick }) => (
            <Tooltip
              title={label}
              key={label}
              placement='top'
              classes={{
                tooltip: classes.tooltip,
              }}
            >
              <IconButton
                key={label}
                size='small'
                className={getClassName(isActive)}
                onClick={onClick}
                aria-label={label}
              >
                <Icon fontSize='small' />
              </IconButton>
            </Tooltip>
          ))}
        </div>
      </div>
    </CustomControl>
  )
}
